<script setup>
import { computed, inject, toRaw } from 'vue'
import { MenuItemList, buildTree, forEachInTree } from '@/Components/Navigation'

const props = defineProps({
  group: {
    type: String,
    required: false,
    default: 'desktop',
  },
})

const viewport = inject('viewport')

const value = defineModel()

const items = computed({
  get() {
    return buildTree(value.value, viewport.value)
  },
  set(updatedItems) {
    forEachInTree(updatedItems, (item, index, parent = null) => {
      value.value[item.id].parent_id = parent ? parent.id : null
      value.value[item.id].viewport[viewport.value].order = index
    })
  },
})
</script>

<template>
  <div class="flex flex-col bg-gray-50">
    <div v-if="items.length === 0" class="p-3 text-sm text-gray-700 text-center">
      <p>{{ __('No items have been added.') }}</p>
    </div>
    <MenuItemList v-else :group="group" v-model="items" />
  </div>
</template>
